import { useContext } from 'react';
import { HelpersContext } from '../../providers/HelpersProvider';

export default function useHelpers() {
  return useContext(HelpersContext);
}
